<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>دریافت جزئیات تخلفات خودرو</h2>
    </div>
    <div v-if="!loading">
      <div v-if="errorMessage">
        <div class="error-message" style="text-align: center; margin: 10px 10px 0">
          <h3 class="loading-title text-color" v-html="errorMessage"></h3>
          <a class="input primary-btn" @click="$router.go(-1)">بازگشت</a>
        </div>
      </div>
      <div v-if="!errorMessage && carFines">
        <div v-if="carFines.priceStatus != 0">
          <h2 class="page-title text-color">نتیجه استعلام خلافی خودرو</h2>
          <div class="fines-summary text-color border-color background-color card">
            <div class="header-item">
              <div class="header-item-title">
                <h3>تعداد تخلفات</h3>
              </div>
              <div class="header-item-value">
                <h2>
                  <span class="blue-text">{{
                    carFines.warningDTOs.length | separator | persian
                  }}</span>
                  عدد
                </h2>
              </div>
            </div>
            <div class="header-item">
              <div class="header-item-title">
                <h3>جمع کل مبلغ تخلفات</h3>
              </div>
              <div class="header-item-value">
                <h2>
                  <span class="blue-text">{{
                    carFines.totalPrice | separator | persian
                  }}</span>
                  ریال
                </h2>
              </div>
            </div>
          </div>
          <div v-for="item in carFines.warningDTOs" :key="item.serialNo">
            <div class="fines text-color border-color background-color">
              <table>
                <tr>
                  <th class="fines-header">تحویل تخلف</th>
                  <th class="fines-header">شرح تخلف</th>
                  <th class="fines-header">مبلغ</th>
                </tr>
                <tr>
                  <td>{{ item.violationDeliveryType }}</td>
                  <td>{{ item.violationType }}</td>
                  <td>{{ item.finalPrice | separator | persian }} ریال</td>
                </tr>
                <tr>
                  <td class="secondary-title first">شماره قبض</td>
                  <td class="secondary-title">محل تخلف</td>
                  <td class="secondary-title last">تاریخ و ساعت</td>
                </tr>
                <tr>
                  <td>{{ item.paperId }}</td>
                  <td>{{ item.violatoinAddress }}</td>
                  <td>{{ item.violationOccureDate | persian }}</td>
                </tr>
                <tr v-if="item.hasImage == 0">
                  <td class="txt-center" colspan="3">
                    <a @click="
                      generatePaymentLink(
                        item.finalPrice,
                        item.paperId,
                        item.paymentId
                      )
                      " type="button" class="payment-button">پرداخت</a>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <!-- <a type="button" @click="ImageInquiryConfirm(item.serialNo)"
                      class="payment-button payment-button-2">تصویر
                      پلاک</a> -->
                    <a type="button" @click="
                      (ImageInquiryFlag = true),
                      ViolationImageInquiry(carId, item.serialNo, item.uniqueID)
                      " class="payment-button payment-button-2">تصویر پلاک</a>
                  </td>
                  <td>
                    <!-- <a type="button" class="payment-button payment-button-2"
                      @click="ViolationImageInquiryConfirm(item.serialNo)">تصویر خودرو</a> -->
                    <a type="button" class="payment-button payment-button-2" @click="
                      (vehicleImageFlag = true),
                      ViolationImageInquiry(carId, item.serialNo, item.uniqueID)
                      ">تصویر خودرو</a>
                  </td>
                  <td class="txt-center">
                    <a @click="
                      generatePaymentLink(
                        item.finalPrice,
                        item.paperId,
                        item.paymentId
                      )
                      " type="button" class="payment-button">پرداخت</a>
                  </td>
                </tr>
                <!-- <tr v-if="item.Status == 1">
                        <td class="txt-right" colspan="3">
                          <span class="success-payment-button">پرداخت شده</span>
                        </td>
                      </tr> -->
              </table>
            </div>
          </div>

          <div v-if="carFines.status !== 200">
            <div class="text-color" style="text-align: center; margin-top: 25px">
              <h3>{{ carFines.Message }}</h3>
            </div>
          </div>
          <div v-if="carFines.warningDTOs.length == 0 &&
            carFines.status === 500 &&
            carFines.message ===
            '[NAJI_SERVICE][ErrCode:502][PlateNo & NationalCode Is Not Matched]'
            ">
            <div class="text-color" style="text-align: center; margin-top: 25px">
              <h3>شماره ملی و شماره پلاک خودرو مطابقت ندارد</h3>
            </div>
          </div>
        </div>
        <div v-if="carFines.priceStatus == 0">
          <h2 class="page-title text-color">نتیجه استعلام خلافی خودرو</h2>
          <div class="fines-summary text-color border-color background-color card">
            <div class="header-item">
              <div class="header-item-title">
                <h3>تعداد تخلفات</h3>
              </div>
              <div class="header-item-value">
                <h2>
                  <span class="blue-text">0</span>
                  عدد
                </h2>
              </div>
            </div>
            <div class="header-item">
              <div class="header-item-title">
                <h3>جمع کل مبلغ تخلفات</h3>
              </div>
              <div class="header-item-value">
                <h2>
                  <span class="blue-text">0</span>
                  ریال
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="alert-bg">
          <div class="alert-box">
            <img src="../../assets/img/logo-bg1.png" width="200px">
            <h3 class="textCenter">با عرض پوزش، سرویس‌های خلافی خودرو در حال حاضر غیرفعال هستند.</h3>
          </div>
        </div> -->
    <PayModal v-if="payFlag" :url="paymentUrl" @close="payFlag = false">
      <template v-slot:header> پرداخت قبض </template>
      <template v-slot:body>
        <lable style="font-size: 14px;" v-if="errorMessageBill">
          <div class="error-message">
            {{ errorMessageBill }}
          </div>
        </lable>
        <lable style="font-size: 14px;" v-else>
          آیا از پرداخت قبض شماره {{ paperId }} به مبلغ
          {{ fineAmount | separator | persian }} ریال اطمینان دارید؟
        </lable>
      </template>
    </PayModal>
    <MainModal v-if="ImageInquiryConfirmFlag" @close="ImageInquiryConfirmFlag = false">
      <template v-slot:header>مشاهده پلاک</template>
      <template v-slot:body>
        برای مشاهده تصویر پلاک خودرو، مبلغ ۵۲,۰۰۰ ريال از کیف پول شما کسر خواهد
        شد.
      </template>
      <template v-slot:footer>
        <div style="display: flex;">
          <a class="mar10r mar10l primary-color" @click="
            (ImageInquiryConfirmFlag = false),
            (ImageInquiryFlag = true),
            ViolationImageInquiry(carId, serialNo, uniqueID)
            ">مشاهده</a>
          <a class="mar10r mar10l" @click="ImageInquiryConfirmFlag = false">انصراف</a>
        </div>
      </template>
    </MainModal>
    <MainModal v-if="ImageInquiryFlag" @close="ImageInquiryFlag = false">
      <template v-slot:header>تصویر پلاک</template>
      <template v-slot:body>
        <center v-if="ViolationImage.plateImage">
          <template v-if="inquiryServiceEnum == 1">
            <img :src="`data:image/png;base64,${ViolationImage.plateImage}`" style="max-width: 100%;" />
          </template>
          <template v-else-if="inquiryServiceEnum == 2">
            <img :src="`${ViolationImage.plateImage}`" style="max-width: 100%;" />
          </template>
          <template v-else>
            <img :src="`data:image/png;base64,${ViolationImage.plateImage}`" style="max-width: 100%;" />
          </template>
        </center>
      </template>
      <template v-slot:footer>
        <a class="mar10r mar10l" @click="ImageInquiryFlag = false">بستن</a>
      </template>
    </MainModal>

    <MainModal v-if="vehicleImageConfirmFlag" @close="vehicleImageConfirmFlag = false">
      <template v-slot:header>مشاهده خودرو</template>
      <template v-slot:body>
        برای مشاهده تصویر خودرو، مبلغ ۵۲,۰۰۰ ريال از کیف پول شما کسر خواهد شد.
      </template>
      <template v-slot:footer>
        <div style="display: flex;">
          <a class="mar10r mar10l primary-color" @click="
            (vehicleImageConfirmFlag = false),
            (vehicleImageFlag = true),
            ViolationImageInquiry(carId, serialNo, uniqueID)
            ">مشاهده</a>
          <a class="mar10r mar10l" @click="vehicleImageConfirmFlag = false">انصراف</a>
        </div>
      </template>
    </MainModal>
    <MainModal v-if="vehicleImageFlag" @close="vehicleImageFlag = false">
      <template v-slot:header> تصویر خودرو </template>
      <template v-slot:body>
        <center v-if="ViolationImage.vehicleImage">
          <template v-if="inquiryServiceEnum == 1">
            <img :src="`data:image/png;base64,${ViolationImage.vehicleImage}`" style="max-width: 100%;" />
          </template>
          <template v-else-if="inquiryServiceEnum == 2">
            <img :src="`${ViolationImage.vehicleImage}`" style="max-width: 100%;" />
          </template>
          <template v-else>
            <img :src="`data:image/png;base64,${ViolationImage.vehicleImage}`" style="max-width: 100%;" />
          </template>
        </center>
      </template>
      <template v-slot:footer>
        <a class="mar10r mar10l" @click="vehicleImageFlag = false">بستن</a>
      </template>
    </MainModal>
    <div v-if="loading">
      <h3 class="loading-title text-color loading-box">
        در حال دریافت جزئیات تخلفات خودرو، لطفا شکیبا باشید...
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import PayModal from "../../components/payModal.vue";
import MainModal from "../../components/MainModal.vue";
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";
import config from "@/config";
import { mapGetters } from "vuex";

export default {
  name: "violation-inquiry",
  components: {
    PayModal,
    MainModal,
    loader,
  },
  props: {
    carId: {
      type: String,
      required: true,
    },
    newCar: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  data() {
    return {
      errorMessage: null,
      errorMessageBill: null,
      loading: false,
      carFines: null,
      ViolationImage: null,
      ViolationImageBase64Flag: null,
      baseUrl: BaseUrl_New,
      payFlag: false,

      ImageInquiryConfirmFlag: false,
      ImageInquiryFlag: false,

      vehicleImageConfirmFlag: false,
      vehicleImageFlag: false,

      inquiryServiceEnum: '',

      fineAmount: "",
      paperId: "",

      serialNo: "",
      uniqueID: "",
      client: 3,

      userInformation: "",
    };
  },
  methods: {
    generatePaymentLink(amount, billId, paymentId) {
      api
        .generateCarFinesPaymentLink(
          amount,
          billId,
          paymentId,
          config.sadadCallback
        )
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.errorMessage = "";
            this.errorMessageBill = null;
            this.payFlag = true;
            this.fineAmount = amount;
            this.paperId = billId;
            this.paymentUrl = response.data.data.redirectUrl;
          } else {
            if (response.data && response.data.messages) {
              this.payFlag = true;
              this.fineAmount = "";
              this.paperId = "";
              this.paymentUrl = "";
              if (response.data.messages[0] == "") {
                this.errorMessageBill =
                  "در حال حاضر امکان پرداخت این قبض مقدور نمی باشد. لطفا دقایقی دیگر تلاش نمایید.";
              } else {
                this.errorMessageBill = response.data.messages[0];
              }
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err.response.data[0].messages;
        });
    },
    // ImageInquiryConfirm(serialNo) {
    //   this.ImageInquiryConfirmFlag = true;
    //   this.serialNo = serialNo;
    // },
    // ViolationImageInquiryConfirm(serialNo) {
    //   this.vehicleImageConfirmFlag = true;
    //   this.serialNo = serialNo;
    // },
    ViolationImageInquiry(carId, serialNo, uniqueID) {
      this.loading = true;
      // alert(carId)
      // alert(serialNo)
      // this.ViolationImage = {
      //   plateImage:
      //     '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',
      //   serialNo: '8905234785',
      //   vehicleImage:
      //     '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',
      //   }
      if (this.carId != 0) {
        api
          .getViolationImageInquiry(carId, serialNo, uniqueID)
          .then((response) => {
            this.errorMessage = "";
            if (response.data && response.data.status === 200) {
              this.ViolationImage = response.data.data;
              this.inquiryServiceEnum = response.data.data.inquiryServiceEnum;
            } else {
              if (
                response.data &&
                response.data.messages &&
                response.data.messages.length > 0
              ) {
                this.errorMessage = response.data.messages[0];
              }
            }
          })
          .catch((err) => {
            this.errorMessage = err.response.data[0].message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        if (this.newCar) {
          api
            .getViolationImageInquiryByInfo(
              this.client,
              this.newCar[0],
              this.newCar[1],
              this.newCar[2],
              this.newCar[3],
              this.newCar[4],
              this.newCar[5],
              this.newCar[6],
              serialNo,
              uniqueID
            )
            .then((response) => {
              if (response.data && response.data.status === 200) {
                this.ViolationImage = response.data.data;
                this.inquiryServiceEnum = response.data.data.inquiryServiceEnum;
              } else {
                if (
                  response.data &&
                  response.data.messages &&
                  response.data.messages.length > 0
                ) {
                  this.errorMessage = response.data.messages[0];
                }
              }
            })
            .catch((err) => {
              this.errorMessage =
                "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
              this.errorMessage = err.response.data.messages[0];
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
  mounted() {
    this.loading = true;

    // this.carFines = {
    //   warningDTOs: [
    //     {
    //       serialNo: '0',
    //       violationOccureDate: '0 - 0',
    //       violationOccureTime: '0',
    //       violatoinAddress: '0',
    //       finalPrice: '0',
    //       paperId: '0',
    //       paymentId: '0',
    //       violationDeliveryType: '0',
    //       violationTypeId: '0',
    //       violationType: '0',
    //       hasImage: '0',
    //     },
    //   ],
    //   priceStatus: '0',
    //   parmDate: '0',
    //   totalPrice: '0',
    //   totalPaperId: '0',
    //   totalPaymentId: '0',
    // }

    // this.carFines = {
    //   warningDTOs: [
    //     {
    //       serialNo: "012530470980",
    //       violationOccureDate: "1401/04/31 - 11:02",
    //       violationOccureTime: "11:02",
    //       violatoinAddress: "تهران جاده قديم بهشت زهرا خروجي",
    //       finalPrice: "525000",
    //       paperId: "3047098000299",
    //       paymentId: "52524749",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2063",
    //       violationType: "نداشتن گواهي معتبر معاينه فني وسيله نقليه",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "012558605434",
    //       violationOccureDate: "1401/08/16 - 20:07",
    //       violationOccureTime: "20:07",
    //       violatoinAddress: "تهران آقايي",
    //       finalPrice: "315000",
    //       paperId: "5860543400294",
    //       paymentId: "84023297",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2111",
    //       violationType: "همراه نداشتن گواهينامه رانندگي",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012558605434",
    //       violationOccureDate: "1401/08/16 - 20:07",
    //       violationOccureTime: "20:07",
    //       violatoinAddress: "تهران آقايي",
    //       finalPrice: "525000",
    //       paperId: "5860543400294",
    //       paymentId: "84023297",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2012",
    //       violationType: "عدم رعايت حق تقدم عبور",
    //       hasImage: "0",
    //     },
    //   ],
    //   priceStatus: "1",
    //   parmDate: "1401/07/19",
    //   totalPrice: "1365000",
    //   totalPaperId: "6685567500190",
    //   totalPaymentId: "0000136520585",
    // };

    // this.carFines = {
    //   warningDTOs: [
    //     {
    //       serialNo: "8905234785",
    //       violationOccureDate: "1400/05/13 - 22:09",
    //       violationOccureTime: "22:09",
    //       violatoinAddress: "قم تهران قم ك 66",
    //       finalPrice: "5250000",
    //       paperId: "523478500290",
    //       paymentId: "525018224",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2177",
    //       violationType:
    //         "تردد غير ضرور وسايل نقليه در معابر شهر هاي با وضعيت نارنجي",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "8916480718",
    //       violationOccureDate: "1400/05/16 - 01:10",
    //       violationOccureTime: "01:10",
    //       violatoinAddress: "قم قم تهران ك 72",
    //       finalPrice: "10500000",
    //       paperId: "1648071800290",
    //       paymentId: "1050014011",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2181",
    //       violationType:
    //         "تردد غير ضرور وسايل نقليه در معابر شهر هاي با وضعيت قرمز",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "2971820453",
    //       violationOccureDate: "1400/05/19 - 18:02",
    //       violationOccureTime: "18:02",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "7182045300290",
    //       paymentId: "63017380",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "0624316709",
    //       violationOccureDate: "1400/05/31 - 14:40",
    //       violationOccureTime: "14:40",
    //       violatoinAddress: "تهران افريقا  پديدار",
    //       finalPrice: "630000",
    //       paperId: "2431670900299",
    //       paymentId: "63015684",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2101",
    //       violationType:
    //         "هرنوع توقف كه منجر به سد معبر و يا اختلال در عبور و مرور گردد",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "8904609545",
    //       violationOccureDate: "1400/06/13 - 19:39",
    //       violationOccureTime: "19:39",
    //       violatoinAddress: "قم تهران قم ك 66",
    //       finalPrice: "10500000",
    //       paperId: "460954500293",
    //       paymentId: "1050018350",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2181",
    //       violationType:
    //         "تردد غير ضرور وسايل نقليه در معابر شهر هاي با وضعيت قرمز",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "8903150398",
    //       violationOccureDate: "1400/06/16 - 01:01",
    //       violationOccureTime: "01:01",
    //       violatoinAddress: "قم قم تهران ك 72",
    //       finalPrice: "10500000",
    //       paperId: "315039800293",
    //       paymentId: "1050018433",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2181",
    //       violationType:
    //         "تردد غير ضرور وسايل نقليه در معابر شهر هاي با وضعيت قرمز",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "3904973432",
    //       violationOccureDate: "1400/07/08 - 00:08",
    //       violationOccureTime: "00:08",
    //       violatoinAddress: "تهران ب آفريقا بالاتر از حكيم",
    //       finalPrice: "2100000",
    //       paperId: "497343200295",
    //       paymentId: "210022756",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2182",
    //       violationType:
    //         "تردد هاي غيرضرور وسايل نقليه در معابر از ساعت 22:00 تا 03:00",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "7636370194",
    //       violationOccureDate: "1400/07/25 - 14:08",
    //       violationOccureTime: "14:08",
    //       violatoinAddress: "تهران خ  افريقا",
    //       finalPrice: "630000",
    //       paperId: "3637019400297",
    //       paymentId: "63021307",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2101",
    //       violationType:
    //         "هرنوع توقف كه منجر به سد معبر و يا اختلال در عبور و مرور گردد",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "2637050887",
    //       violationOccureDate: "1400/07/26 - 12:51",
    //       violationOccureTime: "12:51",
    //       violatoinAddress: "تهران خ افريقا",
    //       finalPrice: "840000",
    //       paperId: "3705088700290",
    //       paymentId: "84021675",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2062",
    //       violationType: "توقف درمحل ايستادن ممنوع (توقف مطلقاً ممنوع)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "3914999940",
    //       violationOccureDate: "1400/07/26 - 14:39",
    //       violationOccureTime: "14:39",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "1499994000290",
    //       paymentId: "63023946",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "8642319550",
    //       violationOccureDate: "1400/08/22 - 11:29",
    //       violationOccureTime: "11:29",
    //       violatoinAddress: "بروجن محور شهرکرد",
    //       finalPrice: "630000",
    //       paperId: "4231955000290",
    //       paymentId: "63023864",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "7981632050",
    //       violationOccureDate: "1400/08/23 - 02:44",
    //       violationOccureTime: "02:44",
    //       violatoinAddress: "قم قم تهران  ك114",
    //       finalPrice: "630000",
    //       paperId: "8163205000297",
    //       paymentId: "63026458",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "9677319177",
    //       violationOccureDate: "1400/08/23 - 17:48",
    //       violationOccureTime: "17:48",
    //       violatoinAddress: "تهران همت",
    //       finalPrice: "1530000",
    //       paperId: "7731917700290",
    //       paymentId: "153024379",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2015",
    //       violationType: "نقص فني موثر يا نقص در سامانه (سيستم ) روشنايي در شب",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "8737201006",
    //       violationOccureDate: "1400/09/10 - 11:59",
    //       violationOccureTime: "11:59",
    //       violatoinAddress: "تهران خرمشهر قنبر زاده",
    //       finalPrice: "210000",
    //       paperId: "3720100600297",
    //       paymentId: "21027065",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2152",
    //       violationType:
    //         "عدم رعايت تقدم عبور عابر يا تجاوز يا توقف وسايل نقليه درگذرگاه عابر پياده",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "6743212380",
    //       violationOccureDate: "1400/09/28 - 14:20",
    //       violationOccureTime: "14:20",
    //       violatoinAddress: "تهران خرمشهر قنبر زاده",
    //       finalPrice: "210000",
    //       paperId: "4321238000292",
    //       paymentId: "21028548",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2152",
    //       violationType:
    //         "عدم رعايت تقدم عبور عابر يا تجاوز يا توقف وسايل نقليه درگذرگاه عابر پياده",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "7744948936",
    //       violationOccureDate: "1400/10/11 - 21:51",
    //       violationOccureTime: "21:51",
    //       violatoinAddress: "تهران زين الدين  مراديان غ ش",
    //       finalPrice: "630000",
    //       paperId: "4494893600296",
    //       paymentId: "63029471",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "8746858285",
    //       violationOccureDate: "1400/10/18 - 19:55",
    //       violationOccureTime: "19:55",
    //       violatoinAddress: "تهران زين الدين  مراديان غ ش",
    //       finalPrice: "630000",
    //       paperId: "4685828500292",
    //       paymentId: "63029805",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "2747537789",
    //       violationOccureDate: "1400/10/20 - 16:14",
    //       violationOccureTime: "16:14",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "4753778900290",
    //       paymentId: "63030130",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "9748677873",
    //       violationOccureDate: "1400/10/28 - 13:59",
    //       violationOccureTime: "13:59",
    //       violatoinAddress: "مناطق تهران خ قنبرزاده",
    //       finalPrice: "630000",
    //       paperId: "4867787300292",
    //       paymentId: "63030487",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2101",
    //       violationType:
    //         "هرنوع توقف كه منجر به سد معبر و يا اختلال در عبور و مرور گردد",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "6756873400",
    //       violationOccureDate: "1400/11/05 - 10:09",
    //       violationOccureTime: "10:09",
    //       violatoinAddress: "تهران دماوند  خجير",
    //       finalPrice: "630000",
    //       paperId: "5687340000297",
    //       paymentId: "63033151",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "4756224074",
    //       violationOccureDate: "1400/11/16 - 21:41",
    //       violationOccureTime: "21:41",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "5622407400290",
    //       paymentId: "63032935",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "9763491302",
    //       violationOccureDate: "1400/12/01 - 19:07",
    //       violationOccureTime: "19:07",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "6349130200294",
    //       paymentId: "63035795",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "8761054864",
    //       violationOccureDate: "1400/12/03 - 11:03",
    //       violationOccureTime: "11:03",
    //       violatoinAddress: "تهران بابايي امام خميني ش غ",
    //       finalPrice: "630000",
    //       paperId: "6105486400291",
    //       paymentId: "63034559",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "0762781260",
    //       violationOccureDate: "1400/12/16 - 13:32",
    //       violationOccureTime: "13:32",
    //       violatoinAddress: "تهران ب بابايي",
    //       finalPrice: "630000",
    //       paperId: "6278126000294",
    //       paymentId: "63035280",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "1764055535",
    //       violationOccureDate: "1400/12/21 - 19:19",
    //       violationOccureTime: "19:19",
    //       violatoinAddress: "تهران باستان",
    //       finalPrice: "630000",
    //       paperId: "6405553500291",
    //       paymentId: "63035870",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2085",
    //       violationType: "توقف دوبله در معابر",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "0764578577",
    //       violationOccureDate: "1400/12/21 - 20:38",
    //       violationOccureTime: "20:38",
    //       violatoinAddress: "تهران ب همت",
    //       finalPrice: "765000",
    //       paperId: "6457857700297",
    //       paymentId: "76535735",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2015",
    //       violationType: "نقص فني موثر يا نقص در سامانه (سيستم ) روشنايي در شب",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "1764062551",
    //       violationOccureDate: "1400/12/22 - 08:07",
    //       violationOccureTime: "08:07",
    //       violatoinAddress: "تهران ب بابايي",
    //       finalPrice: "630000",
    //       paperId: "6406255100295",
    //       paymentId: "63035870",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012300961869",
    //       violationOccureDate: "1401/01/14 - 18:55",
    //       violationOccureTime: "18:55",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "96186900291",
    //       paymentId: "63017549",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "4782907914",
    //       violationOccureDate: "1401/02/15 - 14:47",
    //       violationOccureTime: "14:47",
    //       violatoinAddress: "تهران بازار گل محلاتي",
    //       finalPrice: "630000",
    //       paperId: "8290791400292",
    //       paymentId: "63004648",
    //       violationDeliveryType: "الصاقي",
    //       violationTypeId: "2101",
    //       violationType:
    //         "هرنوع توقف كه منجر به سد معبر و يا اختلال در عبور و مرور گردد",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012303266956",
    //       violationOccureDate: "1401/02/27 - 16:57",
    //       violationOccureTime: "16:57",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "326695600294",
    //       paymentId: "63017541",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "019267210033",
    //       violationOccureDate: "1401/02/30 - 21:59",
    //       violationOccureTime: "21:59",
    //       violatoinAddress: "تهران فرودگاه امام خميني ره",
    //       finalPrice: "306000",
    //       paperId: "6721003300294",
    //       paymentId: "30617521",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2160",
    //       violationType:
    //         "عدم استفاده از كمربند ايمني توسط راننده يا سرنشينان وسيله نقليه درحال حركت( غير استثنائات قانوني) در معابر شهري وروستايي",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012304856898",
    //       violationOccureDate: "1401/02/31 - 01:53",
    //       violationOccureTime: "01:53",
    //       violatoinAddress: "تهران ياسيني-باقري جنوب به شمال",
    //       finalPrice: "630000",
    //       paperId: "485689800290",
    //       paymentId: "63017547",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "0803897095",
    //       violationOccureDate: "1401/05/01 - 09:55",
    //       violationOccureTime: "09:55",
    //       violatoinAddress: "تهران بزرگراهاي تهران بزرگ",
    //       finalPrice: "630000",
    //       paperId: "389709500290",
    //       paymentId: "63012588",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012532815724",
    //       violationOccureDate: "1401/05/02 - 20:37",
    //       violationOccureTime: "20:37",
    //       violatoinAddress: "تهران زين الدين  مراديان غ ش",
    //       finalPrice: "630000",
    //       paperId: "3281572400298",
    //       paymentId: "63017547",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "1808938948",
    //       violationOccureDate: "1401/05/05 - 10:04",
    //       violationOccureTime: "10:04",
    //       violatoinAddress: "تهران بزرگراهاي تهران بزرگ",
    //       finalPrice: "1050000",
    //       paperId: "893894800296",
    //       paymentId: "105012967",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2014",
    //       violationType:
    //         "استفاده از تلفن همراه يا وسايل ارتباطي مشابه در حين رانندگي(در سرعت بالاي 60 کيلو متر)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012534195464",
    //       violationOccureDate: "1401/05/06 - 15:41",
    //       violationOccureTime: "15:41",
    //       violatoinAddress: "تهران دماوند  خجير",
    //       finalPrice: "630000",
    //       paperId: "3419546400290",
    //       paymentId: "63017546",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "9810042007",
    //       violationOccureDate: "1401/05/08 - 15:55",
    //       violationOccureTime: "15:55",
    //       violatoinAddress: "تهران زين الدين",
    //       finalPrice: "630000",
    //       paperId: "1004200700294",
    //       paymentId: "63017460",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012535228350",
    //       violationOccureDate: "1401/05/08 - 17:20",
    //       violationOccureTime: "17:20",
    //       violatoinAddress: "تهران زين الدين  مراديان غ ش",
    //       finalPrice: "630000",
    //       paperId: "3522835000297",
    //       paymentId: "63017547",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "012538638749",
    //       violationOccureDate: "1401/05/11 - 18:07",
    //       violationOccureTime: "18:07",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "3863874900299",
    //       paymentId: "63017547",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "012529794957",
    //       violationOccureDate: "1401/05/13 - 17:24",
    //       violationOccureTime: "17:24",
    //       violatoinAddress: "شهرکرد م اصلي",
    //       finalPrice: "630000",
    //       paperId: "2979495700295",
    //       paymentId: "63017541",
    //       violationDeliveryType: "تسليمي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //     {
    //       serialNo: "012539367803",
    //       violationOccureDate: "1401/05/19 - 16:25",
    //       violationOccureTime: "16:25",
    //       violatoinAddress: "تهران زين الدين  اتحاد غ ش",
    //       finalPrice: "630000",
    //       paperId: "3936780300295",
    //       paymentId: "63017541",
    //       violationDeliveryType: "دوربين",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "1",
    //     },
    //     {
    //       serialNo: "012533115428",
    //       violationOccureDate: "1401/05/23 - 09:48",
    //       violationOccureTime: "09:48",
    //       violatoinAddress: "تهران بزرگراهاي تهران بزرگ",
    //       finalPrice: "630000",
    //       paperId: "3311542800298",
    //       paymentId: "63017543",
    //       violationDeliveryType: "دوبرگي",
    //       violationTypeId: "2056",
    //       violationType: "تجاوز از سرعت مجاز (تا سي كيلومتر در ساعت)",
    //       hasImage: "0",
    //     },
    //   ],
    //   priceStatus: "1",
    //   parmDate: "1401/06/20",
    //   totalPrice: "62661000",
    //   totalPaperId: "6486028800195",
    //   totalPaymentId: "6266117450",
    // };
    if (this.carId != 0) {
      api
        .getViolationInquiry(this.client, this.carId)
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.carFines = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      if (this.newCar) {
        //console.log(this.userInformation);
        this.newCar = this.newCar.split(",");
        api
          .getViolationInquiryByInfo(
            this.client,
            this.newCar[0],
            this.newCar[1],
            this.newCar[2],
            this.newCar[3],
            this.newCar[4],
            this.newCar[5],
            this.newCar[6]
          )
          .then((response) => {
            if (response.data && response.data.status === 200) {
              this.carFines = response.data.data;
            } else {
              if (
                response.data &&
                response.data.messages &&
                response.data.messages.length > 0
              ) {
                this.errorMessage = response.data.messages[0];
              }
            }
          })
          .catch((err) => {
            this.errorMessage =
              "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
            this.errorMessage = err.response.data.messages[0];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
};
</script>

<style scoped>
/* .page { padding-bottom: 20px; display: flow-root; background: url("~@/assets/img/police.png"); background-repeat: no-repeat; background-position: unset; background-size: 100px; background-position-y: 40px; min-height: 100%; } */
.loading-title {
  text-align: center;
}

.header-item {
  display: flex;
  line-height: 40px;
}

.header-item-title {
  flex: 1;
}

.txt-right {
  text-align: right;
}

.payment-button {
  background-color: #09389f;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
  cursor: pointer;
}

.payment-button-2 {
  background-color: #ffa700;
  padding: 4px 10px;
  color: #09389f;
  border-radius: 5px;
  margin: 10px 5px;
  border: none;
}

.success-payment-button {
  border: solid 1px #155724;
  background-color: #155724;
  padding: 4px 10px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}

.dark .blue-text {
  color: white !important;
}

.fines {
  padding: 0 0 10px 0;
}
</style>
